/*global Promise:true*/
import _ from 'underscore'
import firebase from 'firebase'
import {FirebaseConfig} from '../config'
import {notify} from './init'

firebase.initializeApp(FirebaseConfig);


let loadingCount = 0
export function loadingNew(dispatch){
  if(!loadingCount) {
    // dispatch(notify({event:'loading'}))
  }
  loadingCount ++
}

export function loadingDone(dispatch){
  loadingCount --
  if(!loadingCount) {
    // dispatch(notify({event:'loaded'}))
  }
}


export function emailToKey(email) {
 return email.replace(/\./g, ',');
}

function _watch(url,type,cond){
  return (dispatch,getState) => {
    getRef(url).on(type, snapshot =>{
      let data = snapshot.val()||{}
      if(cond && !cond(data))
        return
      let pre = getState()[url][data.id]
      if(pre){
        dispatch({url,type,data,pre})
      } else {
        dispatch({url,type,data})
      }
    })
  }
}

export function loadOnce(url) {
  return (dispatch) => {
    console.log('loadOnce',url)
    let type = 'value'
    loadingNew(dispatch)
    getRef(url).once(type, snapshot=>{
     dispatch({url, type, data:snapshot.val()||{}})
     loadingDone(dispatch)
   })
  }
}

let isLoad = {}
export function load(url) {
  return dispatch => {
    if(isLoad[url])
      return
    var isFirst = true
    loadingNew(dispatch)
    isLoad[url] = true
    console.log('load',url)
    let type = 'value'
    getRef(url).on('value', snapshot => {
      dispatch({url, type, data:snapshot.val()||{}})
      if(isFirst)
        loadingDone(dispatch)
      isFirst = false
    })
  }
}


export function watch(url,cond) {
  return (dispatch,getState) => {

    dispatch(loadOnce(url))
    dispatch(_watch(url,'child_changed',cond))
    dispatch(_watch(url,'child_removed',cond))
  }
}

export function getUpdateRef(url) {
  return new Update(url)
}

function Update(url) {
  this.ref = getRef(url)
  this.key = ''
  this.data = {}
}

Update.prototype.child = function(child){
  this.key = this.key +'/' + child
  return this
}
Update.prototype.set = function(val=null){
  this.data[this.key] = val
  this.key = ''
  return this
}
Update.prototype.remove = function(){
  this.data[this.key] = null
  this.key = ''
  return this
}
Update.prototype.update = function(){
  this.ref.update(this.data)
  this.key = ''
  this.data = {}
  return this
}

export function getRef(url='/') {
  return firebase.database().ref(url)
}

export function storageRef(url='') {
  return firebase.storage().ref(url)
}

export function purify(obj){
  Object.keys(obj).forEach(key=>{
    if(obj[key]===undefined||obj[key]===''){
      delete obj[key]
      return
    }

    if((typeof obj[key]) === 'object') {
      purify(obj[key])
      if(!Object.keys(obj[key]).length)
        delete obj[key]
    }
  })
}

export function saveIdObject(url,obj={}) {
  let ref = getRef(url)
  purify(obj)
  obj.timestamp = Date.now()

  if(obj.id) {
    ref.child(obj.id).set(obj)
    .catch((error) =>{

      notify({event:'PERMISSION_DENIED',message:'權限不足，請重新登入'})
      console.error('error!!',error);

     });
  } else {
    let objRef = ref.push(obj)
    obj.id = objRef.key
    objRef.update({id:obj.id})
  }
  // console.log('saveIdObject',obj)
  return obj
}

export function deleteIdObject(url,id) {
  if(id){
    getRef(url).child(id).remove()
    // getRef(url).child(id).set({
    //   id,
    //   isDeleted:true,
    //   timestamp:Date.now()
    // })
}
}

export function once(ref){
  return new Promise( fulfill => {
    ref.once('value', snapshot => {
      fulfill(snapshot.val()||{})
    })
  })
}



/** WEBPACK FOOTER **
 ** ./src/app/actions/common.js
 **/